module.exports = __webpack_public_path__ + "img/p1-pic@2x.a15373e7.jpg";